export const env = {
  apiUrl: (globalThis as { __API_URL__?: string }).__API_URL__ || 'http://localhost:8000',
};
